/**
 * Query key factories for TanStack Query
 * Provides type-safe query keys and helper functions
 */

export const queryKeys = {
  // Auth & User queries
  auth: {
    all: ["auth"] as const,
    user: () => [...queryKeys.auth.all, "user"] as const,
  },

  // Account queries
  accounts: {
    all: ["accounts"] as const,
    lists: () => [...queryKeys.accounts.all, "list"] as const,
    list: (filters?: Record<string, unknown>) => [...queryKeys.accounts.lists(), filters] as const,
    details: () => [...queryKeys.accounts.all, "detail"] as const,
    detail: (id: number) => [...queryKeys.accounts.details(), id] as const,
    current: () => [...queryKeys.accounts.all, "current"] as const,
  },

  // Expense queries
  expenses: {
    all: ["expenses"] as const,
    lists: () => [...queryKeys.expenses.all, "list"] as const,
    list: (filters?: string, includeSplits?: boolean) =>
      [...queryKeys.expenses.lists(), filters, includeSplits] as const,
    details: () => [...queryKeys.expenses.all, "detail"] as const,
    detail: (id: number) => [...queryKeys.expenses.details(), id] as const,
    withSplits: (id: number) => [...queryKeys.expenses.details(), id, "splits"] as const,
  },

  // Category queries
  categories: {
    all: ["expense-categories"] as const,
    lists: () => [...queryKeys.categories.all, "list"] as const,
    details: () => [...queryKeys.categories.all, "detail"] as const,
    detail: (id: number) => [...queryKeys.categories.details(), id] as const,
  },

  // Partner queries
  partners: {
    all: ["partners"] as const,
    lists: () => [...queryKeys.partners.all, "list"] as const,
    details: () => [...queryKeys.partners.all, "detail"] as const,
    detail: (id: number) => [...queryKeys.partners.details(), id] as const,
  },

  // Dashboard queries
  dashboard: {
    all: ["dashboard-analytics"] as const,
    analytics: (filters?: string) => [...queryKeys.dashboard.all, filters] as const,
  },
} as const
